import { FC } from "react";

import { t } from "i18n/i18n";
import { LinkButton } from "mds/components/buttons/LinkButton";

type MoreItemsButtonProps = {
  count: number;
  maxItems: number;
  onClick: () => void;
};

export const MoreItemsButton: FC<MoreItemsButtonProps> = ({ count, maxItems, onClick }) => {
  const moreCount = count - maxItems;

  return (
    <div className="mt-2 flex justify-end">
      <LinkButton size="s" onClick={onClick}>
        {t("common.more_items", { count: moreCount })}
      </LinkButton>
    </div>
  );
};
